var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.routeClass, { fadeOut: _vm.refreshing }],style:(_vm.appStyle),attrs:{"id":"app"}},[_c('router-view'),_c('loading-screen-component'),(_vm.isFooterVisible)?_c('footer-component',{class:_vm.footerClass}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }